import dayjs from 'dayjs';
import {
  mapper,
} from '@shared/lib';
import {
  LockedStatusEnum,
  UserRegistrationStatusEnum
} from '@shared/types';
import {
  UserKycStatusEnum
} from '@entities/session';

export type Referral = {
  partyId: number;
  regDate: string;
  referDate: string;
  kycPassed: boolean;
  maskedEmail: string;
  kycStatus: UserKycStatusEnum;
  lockedStatus: LockedStatusEnum;
  regStatus: UserRegistrationStatusEnum;
  referralRewarded: boolean;
  lockedStatusPassed: boolean;
  depositAmountPassed: boolean;
};

export type MapReferral = (data: any) => Referral;
export const mapReferral: MapReferral = mapper([
  { name: 'partyId', from: 'partyId' },
  { name: 'referDate', from: 'referDate' },
  { name: 'kycPassed', from: 'kycPassed' },
  { name: 'kycStatus', from: 'kycStatus' },
  { name: 'regStatus', from: 'regStatus' },
  { name: 'lockedStatus', from: 'lockedStatus' },
  { name: 'maskedEmail', from: 'maskedEmail' },
  { name: 'referralRewarded', from: 'referralRewarded' },
  { name: 'lockedStatusPassed', from: 'lockedStatusPassed' },
  { name: 'depositAmountPassed', from: 'depositAmountPassed' },
  {
    name: 'regDate',
    from: 'regDate',
    transform: (regDate: string) => {
      const date = dayjs(regDate, 'DD-MM-YYYY HH:mm:ss');
      return date.format('DD/MM/YYYY');
    }
  }
]);